module.exports = function() {
    $('.pulsepoint-header-nav a, a.hero-overlay').click(function() {
        var $headerLink = $(this);
        if ($headerLink.attr('href').indexOf('#') !== -1) {
            var $targetLink = $('.module-anchor[data-anchor-tag=' + $(this).attr('href').replace('#', '') + ']');
            if ($targetLink.length) {
                var $moduleParent = $targetLink.parentsUntil('body').last();
                var newTopPosition = $moduleParent.offset().top;

                var marginTop = parseInt(window.getComputedStyle($moduleParent[0]).getPropertyValue('margin-top')
                    .match(/(\d|\.|-)+/));
                var paddingTop = parseInt(window.getComputedStyle($moduleParent[0]).getPropertyValue('padding-top')
                    .match(/(\d|\.|-)+/));

                if (!isNaN(marginTop) && marginTop > 0) {
                    newTopPosition -= marginTop;

                    if (!isNaN(paddingTop) && paddingTop > 0) {
                        newTopPosition += paddingTop;
                    }
                }

                var $header = $('.pulsepoint-header');
                $header.removeClass('pulsepoint-header-open');

                var $duplicateHeader = $header.clone();
                $duplicateHeader.css('visibility', 'hidden');
                $duplicateHeader.addClass('pulsepoint-header-sticky');

                $('body').append($duplicateHeader);

                setTimeout(function() {
                        var backgroundColor = window.getComputedStyle($duplicateHeader[0])
                            .getPropertyValue('background-color');

                        var isTransparent = false;

                        if (backgroundColor.indexOf('rgba') === 0) {
                            var rgbaRegex = /rgba\((\d+),[ ]?(\d+),[ ]?(\d+),[ ]?([\d.]+)\)/g;
                            var matches = rgbaRegex.exec(backgroundColor);
                            var alpha = parseFloat(matches[4]);

                            if ($duplicateHeader.is(':hidden') || alpha <= 0.001) {
                                isTransparent = true;
                            }
                        } else if (backgroundColor === 'transparent') {
                            isTransparent = true;
                        }

                        if (!isTransparent) {
                            newTopPosition -= $duplicateHeader.outerHeight();
                        }

                        $('html, body').animate({
                                scrollTop: newTopPosition
                            },
                            750);

                        setTimeout(function() {
                                $duplicateHeader.remove();
                            },
                            0);
                    },
                    0);

                return false;
            }
        }
    });
};